module.exports = __webpack_public_path__ + "img/logo-sm.cd3af774.png";